import { 
  AdvancedNetwork,
  AdvancedTechChip,
  AdvancedFinance,
  AdvancedGrowth,
  AdvancedGlobe,
  AdvancedBadge,
  AdvancedStartup,
  AdvancedService,
  AdvancedRetail
} from './AdvancedIcons';

// 1. 一线互联网：抽象网络节点 (Abstract Hex Network)
export const NetworkNode = AdvancedNetwork;

// 2. 头部科技公司：抽象芯片 (Advanced Tech Chip)
export const TechChip = AdvancedTechChip;

// 3. 大型银行 / 金融：银行大厦 (Bank Building)
export const FinanceBuilding = AdvancedFinance;

// 4. 独角兽 / 高成长：光速火箭 (Hyper Rocket)
export const GrowthCurve = AdvancedGrowth;

// 5. 外企 / 跨国：全息地球 (Holographic Globe)
export const GlobalSphere = AdvancedGlobe;

// 6. 国企 / 央企：机构大厦 (Institutional Building)
export const StateBadge = AdvancedBadge;

// 7. 初创公司：能量迸发 (Energy Burst)
export const StartupSeed = AdvancedStartup;

// 8. 咨询 / 专业服务：专业握手 (Professional Handshake)
export const ServiceFlow = AdvancedService;

// 9. 电商 / 零售：购物袋 (Shopping Bag)
export const RetailTag = AdvancedRetail;
